import { render, staticRenderFns } from "./BranchSetup.vue?vue&type=template&id=01d10d00"
import script from "./BranchSetup.vue?vue&type=script&lang=js"
export * from "./BranchSetup.vue?vue&type=script&lang=js"
import style0 from "./BranchSetup.vue?vue&type=style&index=0&id=01d10d00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports